module.exports = __webpack_public_path__ + "img/CellCycle-LICA_GSE146409.cb0b666d.png";